import {makeAutoObservable, runInAction} from "mobx";
import {socket} from "@services/socket/socketInstanse";
import {sessionStore} from "@services/session";
import {WithSocketEvents} from "@services/socket/WithSocketEvents";
import {Socket} from "socket.io-client";

class SocketStore {

    readonly socketEvents = new WithSocketEvents()

    error = ''

    isError = false

    isLoading = false

    constructor() {
        makeAutoObservable(this)
    }

    setError = (error) => {
        this.error = error
        console.log(this.error)
    }

    reconnectSocket = () =>{
        runInAction(() => {
            this.isLoading = true
        })
        socket.disconnect().connect()
    }

    socketConnectHandler = () => {
        this.setError('')
        const timer = setTimeout(() => {
            runInAction(() => {
                this.isError = false
                this.isLoading = false
            })
            clearTimeout(timer)
        }, 1000)

        console.log('connect')
    }

    socketConnectErrorHandler = (err: Error) => {
        runInAction(() => {
            this.isLoading = false
        })
        if (err.message === "Invalid token") {
            // await this.sessionStore.logout()
        } else {
            console.log("Connection error", err.message)

            this.setError(err.message)
        }
    }

    socketDisconnectHandler = (data: Socket.DisconnectReason) => {
        runInAction(() => {
            this.isError = true
        })
        if (!this.isLoading) {
            const timer = setTimeout(() => {
                if (this.isError) {
                    this.setError(data)
                }
                clearTimeout(timer)
            }, 500)
        }

        console.log('disconnect', data)
    }

    connectionHandler = () => {
        socket.on('connect', this.socketConnectHandler)
        socket.onAny((event, ...args) => {
            console.log('socket: ', event, args)
        })
        socket.on("connect_error", this.socketConnectErrorHandler)
        socket.on('disconnect', this.socketDisconnectHandler)
    }

    closeConnectionHandler = () => {
        socket.off('connect');
        socket.offAny()
        socket.off("connect_error");
        socket.off('disconnect');
    }

}

export const socketStore = new SocketStore()